import fetch from 'cross-fetch';
import { ErrorResponse, LoginHubGetPlayerEmailResponse } from '../response';
import { sameOriginRequestPolicy } from '../actions';
import { LoginHubGetPlayerEmailAction } from './login-hub-get-player-email';

export class RemoteLoginHubGetPlayerEmailAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: LoginHubGetPlayerEmailAction = async (): Promise<LoginHubGetPlayerEmailResponse | ErrorResponse> => {
		const base: string = this.baseUrl || '';

		try {
			const response: Response = await fetch(`${base}/api/login-hub/player-email`, {
				...sameOriginRequestPolicy,
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				},
			});

			return response.json();
		} catch (e: unknown) {
			throw new Error('unexpected');
		}
	};
}
